// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1mImI","search":"Settings_search__35rmM","filter":"Settings_filter__llxvB"};